// extracted by mini-css-extract-plugin
export default {"editBtn":"EditGraduate_editBtn__mU2U-"};